import { Button, Menu, MenuItem, Tooltip } from "@mui/material";
import { useCallback, useState } from "react";
import css from "../../css/modules/toolbar.module.scss";

export function DropDownButton({ id, menuId, children, items, onItemClick, title, selected, onOpen, dataTestid }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = useCallback(
    (event) => {
      setAnchorEl(event.currentTarget);
      if (onOpen) {
        onOpen();
      }
    },
    [onOpen]
  );
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);
  const handleItemClick = (id, onClick) => () => {
    if (onClick) {
      onClick();
    }
    if (onItemClick) {
      onItemClick(id);
    }
    handleClose();
  };
  return (
    <>
      <Tooltip title={title}>
        <Button
          className={css.iconBtn}
          id={id}
          aria-controls={open ? { menuId } : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          data-testid={dataTestid ? "tb_depview_timescale_select" : undefined }
          onClick={handleClick}
        >
          {children}
        </Button>
      </Tooltip>
      {!!items.length && (
        <Menu
          id={menuId}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": id,
          }}
        >
          {items?.map((i, key) => {
            return (
              <MenuItem key={i.id || key} onClick={handleItemClick(i.id, i.onClick)} selected={i.id === selected}>
                {i.text}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </>
  );
}
